import { TopbarConfigurationCategoryType } from '@/types'

export const processCategoryTypes = (
  categoryTypes?: TopbarConfigurationCategoryType[]
): TopbarConfigurationCategoryType[] => {
  if (!categoryTypes) {
    return []
  }

  const experienceCategoryIndex = categoryTypes.findIndex((type) => type.categoryType === 'EXPERIENCE')

  if (experienceCategoryIndex !== -1) {
    categoryTypes[experienceCategoryIndex].categories = categoryTypes[experienceCategoryIndex].categories.filter(
      (category) => category.name !== 'Experiences'
    )
  }

  return categoryTypes
}
